import { Link } from "react-router-dom";

export default function SiteIntro() {
  return (
    <section className="w-full bg-secondary-900 py-14 md:py-16" aria-label="关于本站">
      <div className="mx-auto grid w-full max-w-[1320px] gap-8 px-4 md:px-8 lg:grid-cols-2 lg:items-center lg:gap-14">
        <div className="relative overflow-hidden rounded-lg">
          <div className="h-[240px] w-full md:h-[320px]">
            <img
              src="https://readdy.ai/api/search-image?query=Quiet%20archival%20film%20library%20interior%20with%20wooden%20shelves%20of%20film%20canisters%2C%20warm%20amber%20desk%20lamp%2C%20soft%20dusty%20light%20through%20a%20window%2C%20muted%20sepia%20tones%20with%20deep%20burgundy%20accents%2C%20editorial%20photography%2C%20no%20text%2C%20no%20lettering&width=1200&height=800&seq=about-archive-room&orientation=landscape"
              alt="影视资料整理室场景"
              title="苍井空电影 - 影视资料整理"
              className="h-full w-full object-cover object-center"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/70 to-transparent" />
          <p className="absolute bottom-4 left-4 text-[11px] tracking-[0.2em] text-background-200">
            FILM ARCHIVE · 2026
          </p>
        </div>

        <div>
          <p className="flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-accent-400">
            <span className="h-px w-6 bg-accent-400" />
            About the archive
          </p>
          <h2 className="mt-3 font-heading text-2xl leading-snug text-background-50 md:text-[32px]">
            把作品资料整理好，
            <br className="hidden md:block" />
            再慢慢谈感受
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-background-300">
            苍井空电影是一个由影迷维护的影视资料站。我们按年份、题材与创作团队梳理作品信息，
            同时收录来自观众视角的影评与观后笔记。这里没有夸张的标题，也没有为了流量拼凑的内容，
            只有尽量准确的资料和认真写下的文字。
          </p>
          <div className="mt-6 grid grid-cols-3 gap-4 border-t border-secondary-700 pt-5">
            <div>
              <p className="font-heading text-2xl text-accent-400">12</p>
              <p className="mt-1 text-[11px] text-background-400">收录作品</p>
            </div>
            <div>
              <p className="font-heading text-2xl text-accent-400">14</p>
              <p className="mt-1 text-[11px] text-background-400">影评长文</p>
            </div>
            <div>
              <p className="font-heading text-2xl text-accent-400">6</p>
              <p className="mt-1 text-[11px] text-background-400">题材分类</p>
            </div>
          </div>
          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-500/50 px-5 py-2.5 text-sm text-background-100 transition-colors hover:border-accent-400 hover:text-accent-400"
          >
            了解站点定位与内容范围
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}